import styled from 'styled-components';
import { Persona } from '@fluentui/react/lib/Persona';
import { css } from 'styled-components';

const sharedStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 0.4rem;
`;

export const RequestDetailsApprovalContainerStyle = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const RequestDetailsApprovalStatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const RequestDetailsApprovalPersonaContainer = styled.div`
  display: flex;
`;

export const RequestDetailsApprovalPersona = styled(Persona)`
  pointer-events: none;
  .ms-TooltipHost {
    display: none;
  }
`;

export const RequestDetailsApprovalPersonaText = styled.p`
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  color: ${(props) => props.theme.popupParagraphColor};
  margin-left: -8px;
  padding: 2px;
`;

export const RequestDetailsApprovalComment = styled.p`
  height: 50px;
  width: 100%;
  color: ${(props) => props.theme.popupParagraphColor};

  @media (max-width: 710px) {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const RequestDetailsApproval = styled.div`
  ${sharedStyle}
  width: 30%;
`;

export const RequestDetailsApprovalBy = styled.div`
  ${sharedStyle}
  width: 30%;

  @media (max-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsApprovalByMobile = styled.div`
  ${sharedStyle}
  width: 100%;

  @media (min-width: 710px) {
    display: none;
  }
`;

export const RequestDetailsApprovalParagraph = styled.p`
  color: ${(props) => props.theme.popupParagraphColor};
  font-size: 14px;
  font-weight: 400;
  height: 24px;

  @media (max-width: 710px) {
    font-size: 16px;
    font-weight: 400;
  }
`;
